<template>
  <div class="box" :style="{ backgroundImage: 'url(' + loginBgImg + ')' }">
    <div class="header">嘉康利官方商城</div>
    <!-- <div class="div_logo"><img src="../assets/registerLogo.png" class="logo"></div> -->

    <div class="content" v-if="loginFished == false">
      <div class="tabs">
        <span @click="changeTab(0)" :class="tabIndex === 0 ? 'active' : 'unactive'">会员登录</span>
        <span @click="changeTab(1)" :class="tabIndex === 1 ? 'active' : 'unactive'">手机号码登录</span>
      </div>

      <div class="input" v-if="tabIndex === 0">
        <div class="item">
          <!-- <span>会员编号/手机号</span> -->
          <el-input v-model="loginId" placeholder="请输入会员编号或手机号" clearable></el-input>
        </div>
        <div class="item" style="margin-top: 24px;">
          <!-- <span>会员密码</span> -->
          <el-input v-model="code" type="password" maxlength="30" placeholder="请输入会员密码"></el-input>
        </div>
        <!-- <div class="item controls"> 
          <span><el-checkbox fill="#308A78" v-model="rememberMe" :checked="rememberMe"/>记住密码</span> 
          <span @click="gotoFindPwd()" style="padding-top: 2px;">找回密码</span>
        </div>  -->
      </div>

      <div class="input" v-if="tabIndex === 1">
        <div class="item">
          <!-- <span>手机号码</span> -->
          <el-input v-model="loginId" placeholder="请输入手机号码" clearable></el-input>
        </div>
        <div class="item">
          <!-- <span>验证码</span> -->
          <el-input v-model="code" placeholder="请输入验证码"></el-input>
          <div class="code" @click="sendCode" :disabled="isCounting">{{ sendCodeBtnTxt }}</div>
        </div>
      </div>


      <div class="policy_zone"> 
        <span @click="showPopup">
        <el-checkbox ref="chkPolicyAgree" :checked="isAgree" v-model="isAgree" /><span style="color:gray">阅读并同意</span>
        <span @click="showPopup" style="color:#4096E3;">《嘉康利隐私政策》</span>   
        </span>
      </div>
      <el-button class="login_btn" @click="memberLogin" ref="login_btn" :disabled="isComplete == false">登录</el-button>

      <div class="doc" >
        <span class="goreg" @click="gotoRegister()" >注册会员</span> 
        <span @click="gotoFindPwd()" style="padding-top: 2px;">找回密码</span>
        <PrivacyPopup :isVisible="isPopupVisible" @close="hidePopup" />
      </div>
      <!-- <div class="errMsg">
        <span>{{ errorMsg }}</span>
      </div> -->
    </div>
    <!-- <div @click="gotoLoginSucess">...</div> -->
    <LoginSucess :loginFishedTitle="loginFishedTitle" :isVisible="loginFished" :loginMbNo="loginMbNo"
      :loginMbName="loginMbName" :loginMbType="loginMbType" :loginPhone="loginPhone" :jumpUrl="jumpUrl" />
  </div>
</template>

<script>
  import PrivacyPopup from '../components/PrivacyPopup.vue';
  import LoginSucess from './LoginSucess.vue';
  import { requestApi } from '@/utils/request';
  import { MessageBox } from 'element-ui';
  import Cookies from 'js-cookie';

  export default {
    components: {
      LoginSucess,
      PrivacyPopup
    },
    data() {
      return {
        isPopupVisible: false,
        isAgree: false,
        policy_reading: 0,
        source: 1,
        loginId: "",
        code: "",
        // loginId: "18510243296",
        // loginId: "12290351",
        // code: "650462",
        // loginId: "10660767",
        // code: "123456",
        loginMbNo: "",
        loginMbName: "",
        loginMbType:"",
        loginPhone: "",
        jumpUrl: "",
        shaklee_id: "",
        loginFished: false,
        loginFishedTitle: "登录成功，即将自动跳转",
        pageTitle: "嘉康利官方商城",
        tabIndex: 0,
        loginBgImg: 'https://prodcdn.shaklee.com.cn/shaklee/upload/register-bg01.png',
        errorMsg: "",
        isCounting: false,
        countdown: 60,
        sendCodeBtnTxt: "发送验证码",
        loadingInstance: null,
        rememberMe:false,
        isLoginStarting:false,
        isSendCodeStarting:false,
      }
    },
    computed:{
      isComplete() {
        // console.log(this.loginId + this.code);
        return this.loginId != "" && this.code != "";
      }
    },
    methods: {
      saveCredentials() {
        console.log('saveCredentials');
        if (this.rememberMe) {
          // 记住用户名和密码
          Cookies.set('loginId', this.loginId, { expires: 14 }); // 有效期14天
          Cookies.set('loginPwd', this.code, { expires: 14 }); 
          Cookies.set('rememberPwd', 1, { expires: 14 }); 
        } else {
          // 不记住用户名和密码
          Cookies.remove('loginId');
          Cookies.remove('loginPwd');
          Cookies.remove('rememberPwd');
        }
      },
      initLoginInfo() {
        const rememberPwd = Cookies.get('rememberPwd');
        this.isLoginStarting = false;
        this.rememberMe = rememberPwd == 1;
        if (this.tabIndex == 0 && this.rememberMe) {
          this.loginId = Cookies.get('loginId');
          this.code = Cookies.get('loginPwd');
          // this.isAgree = true;
          // this.policy_reading = 1;
        }
      },

      changeTab(index) {
        this.tabIndex = index;
        this.loginId= "";
        this.code= "";
        this.errorMsg = "";
        this.initLoginInfo();
      },
      gotoLoginSucess() {
        this.loginFished = !this.loginFished;
        this.errorMsg = "";
      },
      gotoFindPwd() {
        this.$router.push({ path: '/findpwd' })
      },
      gotoRegister() {
        this.$router.push({ path: '/register' })
      },
      // 隐私协议
      showPopup() {
        this.isPopupVisible = true;
      },
      hidePopup() {
        // console.log('hidePopup before', this.isAgree, this.policy_reading);
        this.isPopupVisible = false;
        this.isAgree = true;
        this.policy_reading = 1;
        this.errorMsg = "";
        // console.log('hidePopup', this.isAgree, this.policy_reading);
        //登录已经触发，勾选后自动执行登录
        if (this.isLoginStarting) {
          this.memberLogin();
        } else if (this.tabIndex == 1 && this.isSendCodeStarting) {
          this.sendCode();
        }
      },

      checkPhone() {
        const phoneRegex = /^1[3-9]\d{9}$/;
        if (this.loginId == "" || !phoneRegex.test(this.loginId)) {
          this.errorMsg = "请填写正确手机号";
          return false;
        }
        return true;
      },

      memberLogin() {
        this.errorMsg = "";
        this.loginFished = false;
        this.isLoginStarting = true;
        if (this.policy_reading != 1) {
          this.errorMsg = "请先勾选同意隐私政策";
          return;
        }
        if (this.loginId == "" || this.code == "") {
          this.errorMsg = "请填写完整登录信息";
          return;
        }
        if (this.tabIndex == 0) {
          if (this.loginId.length < 5) {
            this.errorMsg = "请填写正确的会员编号";
            return;
          }
          if (this.code.length < 6) {
            this.errorMsg = "请填写正确的密码";
            return;
          }
        } else {
          if (!this.checkPhone()) {
              return;
          }
          if (this.code.length < 6) {
            this.errorMsg = "请填写正确的验证码";
            return;
          }
        }

        var wxOpenId = this.$route.query.wxOpenId;
        if (wxOpenId && wxOpenId != '') {
          Cookies.set('wxOpenId', wxOpenId, { expires: 7 }); // 有效期1天
        } else {
          wxOpenId = Cookies.get('wxOpenId');
          if (!wxOpenId || wxOpenId === '') {
            wxOpenId = '';
          }
        }
        // this.$refs.login_btn.disabled = true;
        const loginParams = {
          source: this.tabIndex == 0 ? 1 : 2,
          login_id: this.loginId,
          code: this.code,

          policy_reading: this.policy_reading,
          platform: 1,
          wx_openid: wxOpenId 
        };
        // console.log(loginParams);
        const loginUrl = "/member/login";
        const respData = this.requestApi(loginUrl, loginParams, 1);
        // console.log('memberLogin <<<',respData);
        // if (loginResult) {
        respData.then(result => {
          if (result === false) {
            return;
          }
          // console.log('memberLogin success ',result);
          this.loginMbNo = result.mb_no;
          this.loginMbName = result.mb_name;
          this.loginMbType = result.role;
          this.loginPhone = result.login_phone;
          this.jumpUrl = result.jump_url;
          this.loginFished = true;
          if (this.tabIndex == 0) {
            this.saveCredentials();
          }
        }).catch(error => {
          this.loginFished = false;
          this.errorMsg = error;
          return;
        });
        // this.$refs.login_btn.disabled = false;
      },

      sendCode() {
        // 发送验证码的逻辑（这里假设已经发送成功）
        if (this.isCounting) {
          console.log("sendCode is working");
          return;
        }
        if (this.policy_reading != 1) {
          this.errorMsg = "请先勾选同意隐私政策";
          this.isSendCodeStarting = true;
          return;
        }
        if (!this.checkPhone()) {
          return;
        }
        console.log("sendCode");
        this.isCounting = true;

        const sendCodeParams = {
          login_id: this.loginId,
          platform: 1
        };
        console.log(sendCodeParams);
        const loginUrl = "/member/send_code";
        const respData = this.requestApi(loginUrl, sendCodeParams, 1);
        respData.then(result => {
          this.code= "";
          if (result === false) {
            this.isCounting = false;
            return;
          }
          this.isSendCodeStarting = false;
          // this.sendCodeBtnTxt = "发送成功";
          // this.$message({
          //   type: 'info',
          //   message: '发送成功',
          //   duration: 1000
          // });
          const interval = setInterval(() => {
            if (this.countdown > 0) {
              this.sendCodeBtnTxt = "重新发送(" + `${this.countdown})`;
              this.countdown--;
            } else {
              clearInterval(interval);
              this.isCounting = false;
              this.sendCodeBtnTxt = '发送验证码';
              this.countdown = 60;
            }
          }, 1000);
        }).catch(error => {
          this.errorMsg = error;
          return;
        });
    },

    async requestApi(funcUrl, params, shakleeId) {
        this.loadingInstance = this.$loading({
           lock: true,
           body:true,
           text: '网络请求中...',
           spinner: 'el-icon-loading',
           background: 'rgba(0, 0, 0, 0.6)',
           target: document.body,
           customClass: ' sk-loading-class'
         });
        try {
          const data = await requestApi(funcUrl, params, shakleeId);
          this.loadingInstance.close();
          if (!data) {
            this.errorMsg = "网络请求失败，请稍后重试";
            return false;
          }
          if (data.code === 0) {
            console.log(funcUrl + "成功", data.data);
            this.errorMsg = "";
            return data.data;
          } else {
            console.log(funcUrl + "失败: " + data.message);
            this.errorMsg = data.message;
            return false;
          }
        } catch (error) {
          this.loadingInstance.close();
          console.error(error);
          return false;
        };
      }
  },
  beforeCreate() {
    //遇到auth登录接口不可用的情况，可以启用下面的代码，强制路由到微盟登录页面
    // var wmLoginUrl = "https://n.weimob.com/bos/account/4019841905257/login?cid=170383257&back=http://t.weimob.com/CW_hY2";
    // console.log('beforeCreate: 实例初始化之后，数据观测和事件配置之前');
    // console.log('即将跳转' + wmLoginUrl);
    // window.location.href = wmLoginUrl;
  },
  created() {
    // console.log('created: 实例创建完成后立即调用');
    document.title = this.pageTitle;
    this.initLoginInfo();
    const userAgent = navigator.userAgent.toLowerCase();
    // console.log(userAgent);
    const isWeChatBrowser = userAgent.includes('micromessenger');
    this.loginFished = isWeChatBrowser;
    this.loginFishedTitle = "登录成功，即将自动跳转";
    if (isWeChatBrowser) {
      this.$router.push('/guide');
      // this.loginFishedTitle = "微信环境不支持该功能, 请在浏览器中打开";
    }
    // console.log(process.env.MINIAPI_HOST);
    var wxOpenId = this.$route.query.wxOpenId;
    if (wxOpenId) {
      Cookies.set('wxOpenId', wxOpenId, { expires: 7 }); // 有效期7天
    }
  },
  watch: {
    errorMsg(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        MessageBox.alert(newVal, '提示', {
          customClass: 'sk-message-box'
        }).then(() =>{
          if (!this.isPopupVisible && !this.isAgree) {
            this.showPopup();
          }

        });
        const intervalErr = setInterval(() => {
          this.errorMsg = "";
        }, 2000);
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100vh;
  overflow: auto;
  background: #fff;
  font-family: pingfang;
  //background-size: cover;
  background-size: 100% 100%;
  //background-position: 20% 90%;
  //background-position: calc(20% + 2px) calc(87% - 2px);
  background-attachment: fixed; /* 背景图片固定在视口中 */
  min-width: 350px;
  min-height: 100vh;
  position: relative;

  .header {
    background: #f1f3f4;
    position: fixed;
    z-index: 999;
    text-align: center;
    width: 100%;
    line-height: 35px;
    font-weight: 700;
    color: #014134;
    font-size: 20px;
    padding-top: 1em;
    padding-bottom: 5px;
  }

  .div_logo {
    width: 80%;
    text-align: left;
    position: fixed; 
    margin-top: 40px;
    padding-top: 1vh;
    padding-bottom: 2vh;
  }

  .logo {
    width: 100px;
    height: 25px;
    padding-left: 35%;
    padding-top: 10px;
    position: fixed;
  }

  .content {
    position: fixed;
    width: 80%;
    margin-top: 105px;
    padding-left: 10%;

    .tabs {
      padding-left: 6px;
      text-align: center;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;

      span {
        font-size: 20px;
        font-weight: 600;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }

      .active {
        font-size: 19px;
        color: #173f35;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }

      .unactive {
        font-size: 19px;
        color: #A2A2A2;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }

      span:last-child {
        margin-left: 4.1667rem;
      }
    }

    .input {
      text-align: left;
      margin-top: 2.0rem;

      span {
        margin-left: 10px;
        font-weight: 500;
      }

      .item:last-child {
        position: relative;
        margin-top: 1.5rem;

        .code {
          position: absolute;
          top: 1.5rem;
          right: 1.4167rem;
          font-size: 1rem;
          color: #3F95E2;
          font-size: 12px;
        }
      }

      /* ::v-deep .el-input__inner {
        background-color: #EEEEEE;
        border: none;
        height: 3.75rem;
        line-height: 3.75rem;
        border-radius: 2.5rem;
        margin-top: 8px;
        color: #A2A2A2;
      } */

      .controls {
        width: 90%;
        margin: 1px auto;
        font-size: 12px;
        display: flex;
        justify-content: space-between;
        color: #A2A2A2;

        /* ::v-deep .el-checkbox__inner {
          border-radius: 7px;
          margin-right: 5px;
        }

        ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: #308A78;
          border-color: #308A78;
        } */
      }
    }
    .policy_zone {
      font-size: 14px;
      margin-top: 1.2em;
      text-align: center;
      margin-left: 1em;
    }

    .login_btn {
      margin-top: 1.2rem;
      width: 98%;
      height: 45px;
      border-radius: 25px;
      border: none;
      background-color: #173f35;
      color: #fff;
    }
    .login_btn:disabled {
      background-color: #909399;
      color: white;
      cursor: not-allowed;
      opacity: 0.7;
    }

    .doc {
      margin-top: .8333rem;
      color: #173f35;
      font-size: 14px;

      /* ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #308A78;
        border-color: #308A78;
      }*/
      .goreg{
        margin-right: 40px;
      }
    }
  }
}
</style>

<style lang="scss">
  .el-input__inner {
    background-color: #EEEEEE;
    border: none;
    height: 3.0rem;
    line-height: 3.0rem;
    border-radius: 2.5rem;
    margin-top: 8px;
    color: black;
  }

  .el-checkbox__inner {
    border-radius: 0px;
    margin-right: 5px;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #308A78;
    border-color: #308A78;
  }

  .errMsg {
    margin-top: 5px;
    color: red;
  }

  /* 调整大小 */
  .sk-message-box.el-message-box {
    width: 80%;
    text-align: center;
  }
  .el-button.el-button--primary {
    color: #fff;
    background-color: #173f35;
    border-color: #173f35;
  }

  /* 调整位置 */
  .sk-message-box.el-message-box__wrapper {
    left: 50% !important;
    top: 50% !important;
    transform: translate(-50%, -50%);
  }

  .el-message-box__btns{
		text-align: center;
	}

  /* 调整尺寸和居中 */
  .sk-loading-class.el-loading-spinner {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>


// WEBPACK FOOTER //
// src/page/login.vue